import { Component, ViewEncapsulation, Input, OnInit, OnDestroy } from '@angular/core';
import { fuseConfig } from 'app/fuse-config/index';
import { FuseConfig } from '@fuse/types';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'ads-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CardComponent implements OnInit, OnDestroy {

    // tslint:disable-next-line:no-input-rename
    @Input('data') project: any;

    private _fuseConfig: FuseConfig;
    public imageUrl: string;
    public isCompanyLogo = false;
    public imageLoaded = false;
    lang = 'sr';
    city = '';

    constructor(
    ) {
        this._fuseConfig = fuseConfig;
    }

    private preloadImage(url): void {
        const img = document.createElement('img');
        img.onload = () => {
            const height = img.height;
            const width = img.width;
            this.imageLoaded = true;
        };
        img.onerror = () => {
            console.log('Error');
            this.imageLoaded = false;
        };

        img.src = url;
    }


    updateUrl(evt): void {
        this.imageUrl = this._fuseConfig.api.url + this.project.api_employ_logo;
        this.preloadImage(this.imageUrl);
        this.isCompanyLogo = true;
    }

    ngOnInit(): void {
        this.imageUrl = this._fuseConfig.api.url + this.project.api_project_banner;
        this.preloadImage(this.imageUrl);

        const cityData = this.project.cityName ? this.project.cityName.split(',') : [];
        if (cityData.length > 0) {
            this.city = cityData[0].trim() + ', ' + cityData[cityData.length - 1].trim();
            this.city = this.city === ', ' ? '' : this.city;
        }
    }

    ngOnDestroy(): void {
    }
}
